export default (cb) => {
  import('slick-carousel').then(() => {
    cb();
  });
};
